import React from 'react';
import 'twin.macro';
import { format } from 'utils/time/format';
import { CahierJournalView } from 'containers/CahierJournal/types';
import { useUser } from 'containers/App/context/useUser';
import getMonth from 'utils/time/getMonth';
import startOfWeek from 'utils/time/startOfWeek';
import endOfWeek from 'utils/time/endOfWeek';
import { useTranslation } from 'react-i18next';
import { useIsBelowBreakpoint } from 'components/ResponsiveSwitcher/useIsBelowSize';

interface Props {
  view: CahierJournalView;
  workingDays: number[];
  date: Date;
}

export function DateTitle(props: Props) {
  const { date, view, workingDays } = props;
  const sundayStart = workingDays.includes(-1);
  const startDayWeek = startOfWeek(date, sundayStart);
  const { locale } = useUser();
  const { t } = useTranslation(['common', 'cahierJournal']);
  const isMobile = useIsBelowBreakpoint('md');
  const endDayWeek = endOfWeek(date, sundayStart);
  const weekViewTitle =
    getMonth(startDayWeek) === getMonth(endDayWeek)
      ? format(startDayWeek, locale, 'MMMM yyyy')
      : `${format(startDayWeek, locale, 'MMM')} - ${format(
          endDayWeek,
          locale,
          'MMM',
        )} ${format(endDayWeek, locale, 'yyyy')}`;

  const dayViewTile = isMobile
    ? format(date, locale, t('common:datePattern.eee_dd/MM/yy'))
    : format(date, locale, t('common:datePattern.EEEE_dd_MMM'));
  const isNotDayView = view !== 'day';
  return (
    <div tw="truncate display capitalize min-w-0">
      {isNotDayView ? weekViewTitle : dayViewTile}
    </div>
  );
}
